import styled from 'styled-components';
import { Box } from '../Box';
import { top, right, bottom, left, zIndex, } from 'styled-system';
import propTypes from '@styled-system/prop-types';
const relativePropTypes = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, propTypes.top), propTypes.right), propTypes.bottom), propTypes.left), propTypes.zIndex);
const Relative = styled(Box) `
  position: relative;
  ${top} ${bottom} ${left} ${right}
  ${zIndex}
`;
Relative.propTypes = relativePropTypes;
Relative.displayName = 'Relative';
export default Relative;
//# sourceMappingURL=Relative.js.map